import { DeleteOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
import { type ImageDescriptionWebPageBlockDataFragment } from '../../../../api/fragments/ImageDescriptionWebPageBlockData';
import SingleUploadField from '../../../../components/fields/SingleUploadField';
import TranslatedTextAreaField from '../../../../components/fields/TranslatedTextAreaField';
import FormFields from '../../../../themes/admin/Fields/FormFields';
import { allowedExtensions } from '../../../../utilities/extensions';
import ResponsiveStyledTable from '../../../shared/ResponsiveStyledTable';
import { type ImageDescriptionBlockInput } from '../shared';
import { StyledIcon } from './shared';

type ImageTableProps = {
    imageTable: ImageDescriptionBlockInput[];
    remove: (index: number) => void;
    name: string;
    disabled?: boolean;
};

type ImageDescriptionProps = ImageDescriptionWebPageBlockDataFragment;

const ImageTable = ({ remove, name, imageTable, disabled = false }: ImageTableProps) => {
    const { t } = useTranslation(['webpageDetails']);
    const buttonList = index => (
        <StyledIcon>
            <DeleteOutlined
                onClick={() => {
                    remove(index);
                }}
                style={{ color: 'var(--ant-primary-color)' }}
            />
        </StyledIcon>
    );

    return (
        <ResponsiveStyledTable
            dataSource={imageTable}
            pagination={false}
            rowKey={(row, index: number) => `${name}_${index.toString()}`}
        >
            <Table.Column<ImageDescriptionProps>
                dataIndex="icon"
                render={(value, record, index) => (
                    <SingleUploadField
                        disabled={disabled}
                        extensions={allowedExtensions.image}
                        name={`${name}.[${index}].icon`}
                    />
                )}
                title={t('webpageDetails:fields.image.descriptions.icon.label')}
            />
            <Table.Column<ImageDescriptionProps>
                dataIndex="title"
                render={(value, record, index) => (
                    <FormFields.TranslatedInputField disabled={disabled} name={`${name}.[${index}].title`} />
                )}
                title={t('webpageDetails:fields.image.descriptions.title.label')}
            />
            <Table.Column<ImageDescriptionProps>
                dataIndex="content"
                render={(value, record, index) => (
                    <TranslatedTextAreaField disabled={disabled} name={`${name}.[${index}].description`} />
                )}
                title={t('webpageDetails:fields.image.descriptions.description.label')}
            />

            {!disabled && (
                <Table.Column
                    key="actions"
                    align="center"
                    render={buttonList}
                    title={t('webpageDetails:actions.action')}
                    width={100}
                />
            )}
        </ResponsiveStyledTable>
    );
};

export default ImageTable;
